(function () {
  'use strict';

  var BUTTON_SELECTOR = '#swym-pdp-wishlist-btn';
  // Fired by variant-picker.js after combined listings swap the product in <main>.
  var VARIANT_UPDATE_EVENT = 'variant:update';

  function getButton() {
    return document.querySelector(BUTTON_SELECTOR);
  }

  // Combined listings morph <main> without a page load, so window.SwymPageData stays on the
  // first product. Read the product from the button, which the morph keeps current.
  function buildProductFromButton(helpers, btn) {
    var empi = Number(btn.getAttribute('data-product-id'));
    var epi = Number(btn.getAttribute('data-variant-id'));

    if (!empi || !epi || epi === empi) return null;

    return {
      empi: empi,
      epi: epi,
      du: helpers.toAbsoluteDu(btn.getAttribute('data-product-url')),
      dt: btn.getAttribute('data-product-title') || '',
      iu: btn.getAttribute('data-product-image') || '',
      pr: Number(btn.getAttribute('data-product-price')) || 0,
    };
  }

  function resolveProduct(swat, helpers, btn, callback) {
    var product = buildProductFromButton(helpers, btn);
    if (product) {
      callback(product);
      return;
    }

    var productUrl = btn.getAttribute('data-product-url');
    if (productUrl) {
      helpers.resolveProduct(swat, { productUrl: productUrl }, callback);
      return;
    }

    callback(helpers.buildFromPageData(window.SwymPageData));
  }

  function refreshState(swat, helpers) {
    var btn = getButton();
    if (!btn) return;

    var empi = Number(btn.getAttribute('data-product-id')) || Number(window.SwymPageData && window.SwymPageData.empi);
    if (!empi) return;

    swat.fetch(function (wishlisted) {
      var currentBtn = getButton();
      // Ignore a late response if the shopper has switched product since.
      if (!currentBtn || (Number(currentBtn.getAttribute('data-product-id')) || empi) !== empi) return;

      updateButtonState(currentBtn, helpers.isProductWishlisted(wishlisted, empi));
    });
  }

  function initWishlistButton(swat) {
    var helpers = window.SwymWishlistHelpers;
    if (!helpers) return;

    // Delegated so clicks keep working if the morph replaces the button.
    document.addEventListener('click', function (event) {
      var btn = event.target instanceof Element ? event.target.closest(BUTTON_SELECTOR) : null;
      if (!btn) return;

      resolveProduct(swat, helpers, btn, function (product) {
        if (!product || !product.epi || !product.empi) return;

        if (btn.classList.contains('swym-added')) {
          helpers.removeProduct(
            swat,
            product.empi,
            function () {
              updateButtonState(btn, false);
              helpers.notifyChange(swat, -1);
            },
            function () {
              refreshState(swat, helpers);
            },
            'pdp'
          );
        } else {
          swat.addToWishList(
            helpers.withSource(product, 'pdp'),
            function () {
              updateButtonState(btn, true);
              helpers.notifyChange(swat, 1);
            },
            function () {
              refreshState(swat, helpers);
            }
          );
        }
      });
    });

    // The morph resets the button's classes, so re-apply saved state for the new product.
    document.addEventListener(VARIANT_UPDATE_EVENT, function () {
      refreshState(swat, helpers);
    });

    refreshState(swat, helpers);
  }

  function updateButtonState(btn, isWishlisted) {
    if (!btn) return;
    btn.classList.toggle('swym-added', isWishlisted);
    btn.setAttribute('aria-label', isWishlisted ? 'Remove from wishlist' : 'Add to wishlist');
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistButton);
})();
